import { Component, OnInit } from '@angular/core';
import { CommunicationAgentDTO, DocumentCategories } from '../../../api/plyca-dtos-v2';
import { SearchSettingDTOModal, searchGenericComponent } from '../../../components/search/searchGeneric.component';
import { UserDTO, OrganizationalUnitDTO } from '../../../api/plyca-dtos';
import { CommunicationBaseFieldComponent } from './communication.basefield.component';
import { UserService } from '../../../user.service';
import { ServiceLocator } from '../../../ServiceLocator';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';


@Component({
  selector: 'communication-field-from',
  templateUrl: './communication.field-from.template.html'
})
export class CommunicationFieldFromComponent extends CommunicationBaseFieldComponent implements OnInit {

  private userService: UserService;

  constructor() {
    super();
    this.userService = ServiceLocator.injector.get(UserService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.editable && !this.model.dto.identifier) {
      // precargar datos del emisor
      let user = this.userService.getUser();
      this.setSender(user);
    }
  }

  public getAgentDescription(sender: CommunicationAgentDTO): string {
    return (sender) ? CommunicationAgentDTO.getAgentDescription(sender) : '';
  }

  public deleteFrom() {
    this.model.dto.sender = undefined;
  }

  public searchFrom() {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('General.search.organizationalUnit'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = new SearchSettingDTOModal('com.nexusit.framework.buscador.interfaz.BuscadorUsuarios');
    this.editDialogOpened.emit(true);
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose,
      (user: UserDTO) => {
        this.setSender(user);
      },
      (error) => {
        this.editDialogOpened.emit(false);
        throw error;
      });
  }

  private setSender(user: UserDTO) {
    if (user) {
      let agent = new CommunicationAgentDTO();
      agent.agentClass = DocumentCategories.Organismo;
      agent.person = user.person;
      let org = user.organizationalUnit;
      if (!org.name && org.identifier) {
        // consultar organismo si no viene la descripcion
        this.subscribe(this.plycaService.get<OrganizationalUnitDTO>(this.configuration.ORGANIZATIONUNIT_SERVICE_URL, org.identifier),
          (orgUnit: OrganizationalUnitDTO) => agent.organizationalUnit = orgUnit, (err: any) => {
            console.error('Error al consultar el organismo ' + org.identifier, err);
            agent.organizationalUnit = org;
          }, () => {
            this.model.dto.sender = agent;
          });
      } else {
        agent.organizationalUnit = org;
        this.model.dto.sender = agent;
      }
    }
  }
}